import { httpClient } from '@/api/httpClient';

const UNSUBSCRIBE_PATH = '/public/unsubscribe/';

interface UnsubscribeStatusApiResource {
  brand_name: string;
  is_unsubscribed: boolean;
}

export interface UnsubscribeStatus {
  brandName: string;
  isUnsubscribed: boolean;
}

function mapApiResourceToUnsubscribeStatus(
  resource: UnsubscribeStatusApiResource
): UnsubscribeStatus {
  return { brandName: resource.brand_name, isUnsubscribed: resource.is_unsubscribed };
}

export async function fetchUnsubscribeStatus(token: string): Promise<UnsubscribeStatus> {
  const response = await httpClient.get<UnsubscribeStatusApiResource>(
    UNSUBSCRIBE_PATH + encodeURIComponent(token)
  );
  return mapApiResourceToUnsubscribeStatus(response.data);
}

export async function unsubscribeWithToken(token: string): Promise<UnsubscribeStatus> {
  const response = await httpClient.post<UnsubscribeStatusApiResource>(
    UNSUBSCRIBE_PATH + encodeURIComponent(token)
  );
  return mapApiResourceToUnsubscribeStatus(response.data);
}
